(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/use-place-bet.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/use-place-bet.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useNotifyUpdatedBalance,
  placeWagerAsync,
  useSetUpMarketplaceBalanceListener
} = svs.components.tipsen.couponId;
const {
  useHistory
} = ReactRouterDOM;
const {
  getDefinitionByProduct
} = svs.components.tipsen.engine.utils;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  unwrapResult
} = RTK;
const {
  userSession,
  urlMapping
} = svs.core;
const {
  PARAM_MARKETPLACE_GAME_ID,
  CouponQueryParams,
  convertSignsTo1X2String,
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const {
  getPaymentDoneMessage
} = svs.components.sport;
const {
  dialog
} = svs.components;
const {
  selectActiveWallet
} = svs.components.tipsen.walletSelectors;
const {
  WALLET_PLAYER,
  WALLET_MARKETPLACE_PLAYER,
  WALLET_MARKETPLACE_RETAILER
} = svs.components.tipsen.wallet.walletType;
const {
  selectSystemType,
  selectIsTransferable,
  selectRelatedDrawCoupon,
  selectSystemSize,
  selectCurrentWeek,
  selectIsCouponExternal,
  selectIsCouponSingleRows
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  selectDrawByProduct
} = svs.components.tipsen.drawProvider.selectors;
const {
  loadOpenedDraws
} = svs.components.sport.drawsRedux.actions;
const {
  useRef,
  useEffect,
  useMemo,
  useCallback
} = React;
const {
  getGameUrl,
  useQueryParam
} = svs.components.lbUtils;
const {
  getTeamUrl
} = svs.components.marketplace.helpers;
const {
  CurrencyFromJupiterString
} = svs.utils.format;
const {
  useDefinition
} = svs.components.tipsen.engine.utils;
const {
  getCompetitionFactoryInstance
} = svs.components.tipsen.competition.competitionFactoryInstance;
const {
  getTitleAndErrorMessageFromWagerResponse
} = svs.components.tipsen.engine.errorHelpers;
const {
  ErrorCodes
} = svs.lbUtils;
const {
  COUPON_SINGLEROWS,
  COUPON_EXTERNAL_SYSTEM
} = svs.components.tipsen.engine.constants.couponTypes;
const {
  handleError
} = svs.components.tipsen.couponId.helpers;
const {
  productIds
} = svs.utils.products;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const TRANSFERRING_QUERY_PARAM = 'transfer';
const {
  analytics
} = svs.components;
const {
  getLogger
} = svs.core.log;
const wagerLogger = getLogger('tipsen:wager');
const hasNewPaymentFlow = svs.core.detect.feature('ft-tipsen-new-wager');
const useTransferable = (couponId, draw) => {
  const dispatch = useDispatch();
  const isCouponTransferable = useSelector(state => selectIsTransferable(state, couponId));
  const wallet = useSelector(selectActiveWallet);
  const definition = useDefinition();
  const transferModel = useMemo(() => definition.getTransfer(draw), [definition, draw]);
  const transferDraw = useSelector(state => selectDrawByProduct(state, transferModel === null || transferModel === void 0 ? void 0 : transferModel.product));
  const isCurrentlyTransferring = useQueryParam(TRANSFERRING_QUERY_PARAM) !== null;
  const isTransferable = !isCurrentlyTransferring && transferModel && isCouponTransferable && (wallet === null || wallet === void 0 ? void 0 : wallet.type) === WALLET_PLAYER && !isSelfService;
  const loadTransferableDraws = useCallback(() => {
    if (isTransferable && !hasNewPaymentFlow) {
      dispatch(loadOpenedDraws(transferModel.drawsApi));
    }
  }, [dispatch, isTransferable, transferModel]);
  const getTransferableName = useCallback(() => {
    const transferDefinition = getDefinitionByProduct(transferModel === null || transferModel === void 0 ? void 0 : transferModel.product);
    return transferDefinition.getDisplayNameByDraw(transferDraw);
  }, [transferDraw, transferModel]);
  return {
    isTransferable,
    loadTransferableDraws,
    getTransferableName,
    transferDraw
  };
};
const trackEventOnJoinedCompetition = competition => {
  if (competition.compType) {
    analytics.trackEvent({
      category: competition.compType,
      action: 'joined team',
      opt_label: 'Individuellt'
    });
  }
};
const getPartialsWagerErrorDialog = (failedWagers, totalPaid) => {
  const totalFailed = failedWagers.reduce((totalAmount, wager) => {
    const bet = wager.bets[0];
    totalAmount += CurrencyFromJupiterString(bet.betAmountSalesGroup1);
    return totalAmount;
  }, 0);
  svs.components.dialog.api.add(new svs.components.dialog.Confirm({
    branding: svs.components.dialog.branding.SPORT,
    icon: 'my-limits',
    type: svs.components.dialog.type.ERROR,
    title: 'Ojdå!',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: "".concat(totalFailed, "kr av ").concat(totalPaid, "kr gick inte att betala.<br>Du kan annulera betalda delar av spelet under Mina spel.")
    }],
    actions: [{
      title: 'Ok',
      type: svs.components.dialog.button.SECONDARY
    }]
  }));
};
const usePlaceBet = (couponId, draw) => {
  const isPaymentStarted = useRef(false);
  const {
    useAskForCompetitionParticipation,
    useCanPlayInCompetitionDraw
  } = getCompetitionFactoryInstance().getCompetitionHooksForCms();
  const dispatch = useDispatch();
  const history = useHistory();
  const wallet = useSelector(selectActiveWallet);
  const relatedCoupon = useSelector(state => selectRelatedDrawCoupon(state, couponId));
  let relatedCouponId;
  if (relatedCoupon) {
    const {
      productId: relatedProductId,
      drawNumber: relatedDrawNumber
    } = relatedCoupon;
    relatedCouponId = "".concat(relatedProductId, "_").concat(relatedDrawNumber, "_pix");
  }
  const {
    isTransferable,
    loadTransferableDraws,
    getTransferableName,
    transferDraw
  } = useTransferable(couponId, draw);
  const transferDrawRef = useRef();
  useEffect(() => {
    transferDrawRef.current = transferDraw;
  }, [transferDraw]);
  const handlePaymentComplete = useCallback(_ref => {
    let {
      price,
      productName,
      signs,
      isSingleRows,
      competitionSignUp = false,
      compDesc = '',
      isPlayingCompetition = false,
      wagerResponses,
      failedWagers,
      errorWagers
    } = _ref;
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has(PARAM_MARKETPLACE_GAME_ID)) {
      searchParams.delete(PARAM_MARKETPLACE_GAME_ID);
      history.replace({
        search: "?".concat(searchParams)
      });
    }
    const successfulWagerClientSerials = wagerResponses.map(res => res.wagerClientSerial).join(',');
    let logInfo = "Payment successful ".concat(successfulWagerClientSerials);
    if (isPlayingCompetition) {
      logInfo += ", in competition [".concat(compDesc, "]");
    }
    wagerLogger.info(logInfo);
    const getMarketplaceUrl = () => {
      if (wallet.type === WALLET_MARKETPLACE_PLAYER) {
        return "".concat(urlMapping.get('marketplace')).concat(getTeamUrl(wallet.meta.GroupId, wallet.meta.GroupName, 'spel', wallet.meta.ContainerId, wallet.meta.ActivatedDrawId));
      }
      return '';
    };
    const tipsetBombenAmount = 0;
    const marketplaceUrl = getMarketplaceUrl();
    const isRetailer = wallet.type === WALLET_MARKETPLACE_RETAILER;
    if (!isRetailer && !isSelfService) {
      history.push('/relaterat');
    }
    const transferTo = {
      abortAction: () => {
        svs.components.dialog.api.close();
      },
      transferAction: () => {
        svs.components.dialog.api.close();
        const getGameUrlOptions = _objectSpread({}, isSingleRows && {
          subPath: "/".concat(TipsenModuleGameUrl.SINGLES)
        });
        let url = getGameUrl({
          productId: transferDrawRef.current.productId,
          drawNumber: transferDrawRef.current.drawNumber,
          options: getGameUrlOptions
        });
        const searchParams = new URLSearchParams();
        searchParams.set(TRANSFERRING_QUERY_PARAM, 1);
        for (const eventSigns of signs) {
          searchParams.append(CouponQueryParams.PARAM_SIGNS, convertSignsTo1X2String(eventSigns));
        }
        url += "".concat(url.includes('?') ? '&' : '?').concat(decodeURIComponent(searchParams));
        location.href = url;
      }
    };
    if (isTransferable && transferDrawRef.current) {
      transferTo.gameName = getTransferableName();
    } else {
      const searchParams = new URLSearchParams(location.search);
      searchParams.delete(TRANSFERRING_QUERY_PARAM);
      history.replace({
        search: "?".concat(searchParams)
      });
    }
    let amount = 0;
    if (wagerResponses.length > 0) {
      wagerResponses.forEach(response => {
        const wagerAmounts = response.wagerAmounts ? response.wagerAmounts.betAmount : response.CreateWagerReply.betAmount;
        amount += parseInt(wagerAmounts, 10);
      });
    }
    if (failedWagers && failedWagers.length > 0) {
      getPartialsWagerErrorDialog(failedWagers, price);
    }
    getPaymentDoneMessage({
      amount,
      productName,
      compDesc,
      competitionSignUp,
      tipsetBombenAmount,
      marketplaceUrl,
      isRetailer,
      transferTo,
      errorWagers,
      numberOfGames: wagerResponses.length
    }, messageObject => {
      dialog.api.add(new dialog.Confirm(messageObject.paymentDoneDialogConfig));
      if (messageObject.transferDialogConfig) {
        dialog.api.add(new dialog.Confirm(messageObject.transferDialogConfig));
      }
    });
  }, [getTransferableName, history, isTransferable, wallet]);
  const shouldUseNewPlaceBet = draw.productId === productIds.BOMBEN || hasNewPaymentFlow;
  const notifyUpdatedBalance = useNotifyUpdatedBalance(shouldUseNewPlaceBet);
  useSetUpMarketplaceBalanceListener(!shouldUseNewPlaceBet);
  const isSingleRows = useSelector(state => selectIsCouponSingleRows(state, couponId));
  const isExternal = useSelector(state => selectIsCouponExternal(state, couponId));
  const systemType = useSelector(state => selectSystemType(state, couponId));
  let selectedSystemType = systemType;
  if (isSingleRows) {
    selectedSystemType = COUPON_SINGLEROWS;
  }
  if (isExternal) {
    selectedSystemType = COUPON_EXTERNAL_SYSTEM;
  }
  const selectedSystemSize = useSelector(state => selectSystemSize(state, couponId, 0));
  const drawCount = useSelector(state => selectCurrentWeek(state, couponId));
  const askForCompetitionParticipation = useAskForCompetitionParticipation({
    selectedSystemType,
    selectedSystemPrice: selectedSystemSize,
    productId: draw.productId,
    drawNumber: draw.drawNumber,
    drawCount
  });
  const canPlayInCompetition = useCanPlayInCompetitionDraw({
    productId: draw.productId,
    drawNumber: draw.drawNumber
  }, true);
  const shouldAskForCompetition = (wallet === null || wallet === void 0 ? void 0 : wallet.type) === WALLET_PLAYER && canPlayInCompetition;
  const placeBetAsync = useCallback(async () => {
    wagerLogger.info("Customer can play in competition: ".concat(canPlayInCompetition));
    if (isSelfService || userSession.hasRole(userSession.roles.PLAYER) || userSession.hasRole(userSession.roles.RETAILER)) {
      try {
        await notifyUpdatedBalance();
      } catch (_unused) {
        wagerLogger.error('notifyUpdatedBalance() error');
      }
      loadTransferableDraws();
      let isPlayingCompetition = false;
      let isCompetitionSignUp = false;
      let competition;
      if (shouldAskForCompetition) {
        try {
          const competitionParticipation = await askForCompetitionParticipation();
          isPlayingCompetition = competitionParticipation.isPlayingCompetition;
          isCompetitionSignUp = competitionParticipation.isCompetitionSignUp;
          competition = competitionParticipation.competition;
        } catch (_unused2) {
          wagerLogger.error('askForCompetitionParticipation() error');
        }
      }
      try {
        const fullfilledPayload = unwrapResult(await dispatch(svs.components.tipsen.engine.actions.placeBet({
          couponId,
          drawNumber: draw.drawNumber,
          productId: draw.productId,
          isPlayingCompetition,
          isCompetitionSignUp,
          competition,
          relatedCouponId
        })));
        if (isCompetitionSignUp && competition) {
          trackEventOnJoinedCompetition(competition);
        }
        if (isSelfService) {
          const {
            totalWagerCount,
            wagerCount
          } = fullfilledPayload.wagerResponses[0];
          if (totalWagerCount !== wagerCount) {
            handleError('Något av dina spel kunde inte läggas i varukorgen');
          }
        } else {
          handlePaymentComplete(fullfilledPayload);
        }
      } catch (error) {
        if (error !== null && error !== void 0 && error.code) {
          const errorCode = parseInt(String(error.code).replace(/\s/g, ''), 10);
          const {
            errorMessage,
            title
          } = getTitleAndErrorMessageFromWagerResponse(errorCode);
          if (errorCode === ErrorCodes.BAD_DRAWSTATE || errorCode === ErrorCodes.REGBET_DISABLED || errorCode === ErrorCodes.DRAW_NOT_OPENED || errorCode === ErrorCodes.ACTIVATED_DRAW_CLOSED || errorCode === ErrorCodes.NOT_ENOUGH_MONEY) {
            wagerLogger.info("fullfilledPayload error: title: ".concat(title, ", message: ").concat(errorMessage));
          } else {
            wagerLogger.error("fullfilledPayload error: title: ".concat(title, ", message: ").concat(errorMessage, ", error: ").concat(JSON.stringify(error)));
          }
        } else {
          const errorMessage = (error === null || error === void 0 ? void 0 : error.name) === 'customError' ? error === null || error === void 0 ? void 0 : error.message : undefined;
          handleError(errorMessage);
          wagerLogger.error("fullfilledPayload error, error: ".concat(JSON.stringify(error)));
        }
      }
    } else {
      svs.components.customer_login.login({
        returnNewCustomer: true
      });
    }
  }, [askForCompetitionParticipation, canPlayInCompetition, couponId, dispatch, draw, handlePaymentComplete, loadTransferableDraws, notifyUpdatedBalance, shouldAskForCompetition, relatedCouponId]);
  const newPaymentCallback = useCallback(async () => {
    if (isPaymentStarted.current) {
      return;
    }
    isPaymentStarted.current = true;
    try {
      return await placeWagerAsync({
        dispatch,
        couponId,
        wallet,
        notifyUpdatedBalance,
        loadTransferableDraws,
        history,
        relatedCouponId,
        isTransferable
      });
    } finally {
      isPaymentStarted.current = false;
    }
  }, [dispatch, couponId, wallet, notifyUpdatedBalance, loadTransferableDraws, history, relatedCouponId, isTransferable]);
  return shouldUseNewPlaceBet ? newPaymentCallback : placeBetAsync;
};
setGlobal('svs.components.tipsen.couponId.usePlaceBet', usePlaceBet);

 })(window);